import { LogType } from "../const";

export const log = (...params: any) => {
  if (process.env.NODE_ENV === `development`) {
    // eslint-disable-next-line no-console
    console.log(...params);
  }
};

export const requestLog = (
  method: string = "",
  url: string = "",
  data: any,
  type: LogType,
  baseURL: string
) => {
  const tag =
    type === LogType.REQUEST || type === LogType.RESPONSE
      ? method
      : LogType.ERROR;
  const colors = {
    [LogType.REQUEST]: "blue",
    [LogType.RESPONSE]: "green",
    [LogType.ERROR]: "red",
  };
  const icons = {
    [LogType.REQUEST]: ">>>",
    [LogType.RESPONSE]: "<<<",
    [LogType.ERROR]: "xxx",
  };

  log(
    `%c${icons[type]} [${tag.toUpperCase()}] | %c${url.replace(
      baseURL,
      ""
    )} \n`,
    `color: ${colors[type]}; font-weight: bold`,
    "color: violet; font-weight: bold",
    data
  );
};
